import { AdminRoutes } from '../features/admin';
// import { lazyImport } from '../utils/lazyImport';

export const adminRoutes = [
  {
    path: '/*',
    element: <AdminRoutes />,
  },
];
